export const color = {
  primary00: "#e2d7cb",
  primary20: "#e1cfbc",
  primary40: "#b78b5c",
  primary60: "#92714f",
  primary80: "#4A3420",
  primary100: "#4A3420",
  secondary00: "#9C7D3E",
  secondary20: "#9C7D3E",
  secondary40: "#9C7D3E",
  secondary60: "#9C7D3E",
  secondary80: "#9C7D3E",
  secondary100: "#9C7D3E",
  black: "#080808",
  neutral20: "#282a2f",
  neutral40: "#2e3f60",
  neutral60: "#BEBEC1",
  neutral80: "#F0F1F5",
  neutral90: "#F9FBFA",
  white: "#ffffff",
}
